<template>
    <b-card no-body>

        <b-modal size="xl" id="agreement" title="Sözleşme" scrollable no-close-on-esc no-close-on-backdrop>
            <draft-offer-agreement v-model="agreement"></draft-offer-agreement>
            <template #modal-footer>
                <v-executer :loading="rejecting" :disabled="accepting || rejecting" variant="danger" text="Reddet" :action="rejectAgreement"></v-executer>
                <v-executer :loading="accepting" :disabled="accepting || rejecting" variant="success" text="Onayla" :action="acceptAgreement"></v-executer>
            </template>
        </b-modal>

        <v-table    ref="table"
                    :fields="fields"
                    name="draft-offer"
                    :buttons="buttons"
                    :items-provider="provider"
                    button-alignment="text-left"
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import CustomerApi from '@/api/customer'
import DraftOfferAgreement from './components/DraftOfferAgreement.vue'
export default {
    components:{
        BCard,
        DraftOfferAgreement
    },
    data() {
        return {
            fields:[
                {name:"Teklif Kodu",key:"DraftOfferCode",thClass:'w-10',sortable:true,sortKey:'PreparedDraftOffer.DraftCode'},
                {name:"Durum",component:true,componentOptions:{name:"customer-draft-price-status/CustomerDraftPriceStatus"},thClass:'w-7',sortable:true},
                {name:"Oluşturulma Tarihi",key:"CreateTime",thClass:'w-10',sortable:true},
                {name:"Proje Adı",key:"FirmLocationName",thClass:'w-25',sortable:true,sortKey:'FirmLocation.LocationName'},
                {name:"Araç Tip(ler)i",key:"VehicleTypesName",thClass:'w-33',sortable:false},
                {name:"Son Güncelleme Tarihi",key:"LastUpdateTime",thClass:'w-10',sortable:true,sortKey:'UpdateTime'},
                {name:"Görüldü",key:"IsAnyoneViewed",thClass:'w-5',sortable:true},
            ],
            buttons:[
                { text:"Taslak Detay",key:"detail",icon:"EyeIcon",variant:"secondary",action:this.getDetail},
                { text:"Sözleşme",key:"agreement",icon:"Edit3Icon",variant:"primary",action:this.getAgreement, condition:(item)=> item.AgreementStep == 1 && item.HasAgreementInformation && item.AgreementInformationStatus == 0},
            ],
            accepting:false,
            rejecting:false,
            agreement:{}
        }
    },
    methods:{
        clearForm(){
            this.agreement = {}
        },
        provider(data){
            return CustomerApi.DraftOffer.Table(data)
        },
        getDetail(item){
            this.$router.push({name:'customer-draft-offer-detail',params:{id:item.Id}})
        },
        getAgreement(item){
            this.$refs.table.rowLoading(true)
            this.clearForm()
            CustomerApi.DraftOffer.AfterSend(item.AgreementInformationId).then(res=>{
                if(res.data.Data){
                    this.agreement = res.data.Data
                    this.agreement.CustomerDraftOfferId = item.Id
                    this.$showModal('agreement')
                }
                this.$refs.table.rowLoading(false)
            }).catch(err=>{ this.$refs.table.rowLoading(false) })
        },
        acceptAgreement(){
            this.accepting = true
            CustomerApi.DraftOffer.AcceptAgreement(this.agreement.CustomerDraftOfferId).then(res=>{
                this.$result(res)
                this.accepting = false
                if(res.data.Success){
                    this.$hideModal('agreement')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.accepting = false
                this.$result(null,err)
            })
        },
        rejectAgreement(){
            this.rejecting = true
            CustomerApi.DraftOffer.RejectAgreement(this.agreement.CustomerDraftOfferId).then(res=>{
                this.$result(res)
                this.rejecting = false
                if(res.data.Success){
                    this.$hideModal('agreement')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.rejecting = false
                this.$result(null,err)
            })
        }
    }
}
</script>

<style>

</style>